import { Alert } from "@mui/material";

type ToastType = "error" | "success" | "warning";

export type Toast = {
  type: ToastType;
  message: string;
  time?: number;
};

export type TostController = {
  toast: Toast | null;
  closeToast: () => void;
  showToast: (toast: Toast) => void;
};

/**
 * @name OnCloseFn
 * @function
 */

/**
 * @prop {Toast} toast The toast to show
 * @prop {OnCloseFn} onClose callback for the close icon click event
 *
 * @author Rajkumar Rathod
 */
export const ToastHost: React.FC<{
  toast: any;
  onClose: () => void;
}> = ({ toast, onClose }) => {
  return (
    toast && (
      <Alert
        variant="filled"
        severity={toast.type}
        onClick={onClose}
        sx={{ padding: "0px 12px" }}
      >
        {toast.message}
      </Alert>
    )
  );
};
